import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import "./css/Introduction.css";

const Introduction = () => {
  const navigate = useNavigate();
  const [isChecked, setIsChecked] = useState(false);

  const handleStart = () => {
    if (isChecked) {
      navigate("/user/form/view/registration/68c7eefbd44999eedb541043");
    } else {
      alert("Please read and agree to the Privacy Policy before continuing.");
    }
  };

  // Path to your PDF in public folder
  const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";
  const documentUrl = `${API_URL}/documents/IGF - PRIVACY POLICY.pdf`;


  return (
    <div>
      {/* Main Content */}
      <main className="intro-main">
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          className="intro-card"
        >
          <div className="intro-header">
              <h1 className="intro-title">
                LOS ANGELES 2028 OLYMPIC GOLF COMPETITION
              </h1>
              <p className="intro-location">LA, USA — 26 July – 11 August 2028</p>
          </div>

            <h1 className="intro-title">
              IGF Games Registration & Regulations Form for Athletes
            </h1>
            <p>Games of the XXXIII Olympiad – LA 2028</p>

            <div>
              <h1 className="intro-title">Important Deadline</h1>
              <p>
                All athletes must complete and sign this form within{" "}
                <strong>3 working days</strong> to participate in the LA 2028 Olympic Games.
              </p>
            </div>

            <div>
              <h1 className="intro-title">Compliance Requirements</h1>
              <ul>
                <li>Respect and comply with the Olympic Charter and World Anti-Doping Code</li>
                <li>Follow International Olympic Committee (IOC) participation conditions</li>
                <li>Adhere to International Golf Federation (IGF) rules</li>
              </ul>
            </div>

            <div>
              <h1 className="intro-title">Next Steps</h1>
              <ol>
                <li>Read the Registration Form</li>
                <li>Complete Personal Information</li>
                <li>Sign the form digitally for confirmation</li>
              </ol>
            </div>

            <div className="intro-privacy">
            <div className="privacy-checkbox">
              <label>
                <input
                  type="checkbox"
                  style={{accentColor: "#D9a128;"}}
                  checked={isChecked}
                  onChange={(e) => setIsChecked(e.target.checked)}
                />{" "}
                I have read and agree to the{" "}
                <a
                  href={documentUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="privacy-link"
                >
                  Privacy Policy
                </a>{" "}
                for the Los Angeles 2028 Olympic Games.
              </label>
            </div>

            <div className="intro-footer">
              <button
                onClick={handleStart}
                className="intro-btn"
                disabled={!isChecked}
                style={{
                  opacity: isChecked ? 1 : 0.6,
                  cursor: isChecked ? "pointer" : "not-allowed",
                }}
              >
                Start Registration Process
              </button>
            </div>
          </div>
        </motion.div>
      </main>
    </div>
  );
};

export default Introduction;
